import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import SocialShareButton from './SocialShareButton';
import s from './SocialShareButtons.scss';
class SocialShareButtons extends React.Component {
    render() {
        const _this_props = this.props, { buttons, url, title, hashtags, via, media, className, buttonClassname } = _this_props, buttonProps = _object_without_properties(_this_props, [
            "buttons",
            "url",
            "title",
            "hashtags",
            "via",
            "media",
            "className",
            "buttonClassname"
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['social-share-buttons'], className)
        }, buttons.map((buttonType)=>/*#__PURE__*/ React.createElement(SocialShareButton, _object_spread({
                key: buttonType,
                type: buttonType,
                className: buttonClassname,
                shareInfo: {
                    url,
                    title,
                    hashtags,
                    via,
                    media
                }
            }, buttonProps))));
    }
}
export default SocialShareButtons;
